import { io, Socket } from "socket.io-client";

const WS_BASE = "wss://ws-chatbot.bolsterup.ai";

let socket: Socket | null = null;

/**
 * Connect to the Bolsterup AI Assistant WebSocket namespace.
 * Reuses the same connection if already connected with the same token.
 */
export function connectAssistant(token: string): Socket {
  if (socket?.connected) return socket;

  // Disconnect any stale connection
  if (socket) {
    socket.disconnect();
  }

  socket = io(`${WS_BASE}/assistant`, {
    auth: { token },
    transports: ["websocket"],
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionAttempts: 10,
  });

  socket.on("connect", () => {
    console.log("[WS] Connected to assistant namespace");
  });

  socket.on("disconnect", (reason) => {
    console.log("[WS] Disconnected:", reason);
  });

  socket.on("connect_error", (err) => {
    console.error("[WS] Connection error:", err.message);
  });

  return socket;
}

/**
 * Get the current socket instance (may be null if not connected).
 */
export function getSocket(): Socket | null {
  return socket;
}

/**
 * Disconnect and clean up the socket connection.
 */
export function disconnectAssistant() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}

/**
 * Send a message to the AI assistant.
 */
export function sendAssistantMessage(params: {
  threadId?: string;
  message: string;
  projectId?: string;
  createThread?: boolean;
  optimisticThreadId?: string;
  source?: string;
  emailContext?: {
    from?: string;
    to: string[];
    cc?: string[];
    subject?: string;
    body?: string;
    itemType?: "compose" | "read";
  };
}) {
  if (!socket?.connected) {
    throw new Error("Not connected to assistant");
  }

  socket.emit("assistant:sendMessage", params);
}

/**
 * Join a thread room to receive updates.
 */
export function joinThread(threadId: string) {
  if (!socket?.connected) return;
  socket.emit("assistant:joinThread", { threadId });
}
